import { Box, Button } from '@mui/material';
import PioneerContent from './PioneerContent';

const PioneerBanner = ({ onOpenModal }) => {
  const handleCta = () => {
    onOpenModal?.('contact', {
      planName: 'נֵר — תכנית חלוצים',
      subject: 'הצטרפות לתכנית החלוצים',
      message: 'שלום,\nאני מעוניין/ת להצטרף לתכנית החלוצים של inorai — מסלול נֵר.\n\nפרטים נוספים:\n',
    });
  };

  const ctaButton = (
    <Button
      variant="contained"
      onClick={handleCta}
      sx={{
        bgcolor: '#9a7209',
        color: 'white',
        fontFamily: 'Heebo, sans-serif',
        fontWeight: 700,
        fontSize: '1rem',
        py: 1.5,
        px: 4,
        borderRadius: 2,
        boxShadow: '0 8px 28px rgba(154,114,9,0.45)',
        '&:hover': {
          bgcolor: '#b8860b',
          transform: 'translateY(-2px)',
          boxShadow: '0 14px 40px rgba(154,114,9,0.55)',
        },
        transition: 'all 0.25s ease',
      }}
    >
      אני רוצה להצטרף לתכנית החלוצים
    </Button>
  );

  return (
    <Box
      className="lp-pioneer-banner"
      sx={{
        background: 'linear-gradient(135deg, #1a3352 0%, #243f5f 40%, #2a4a6a 70%, #1e3a5f 100%)',
        borderRadius: 3.5,
        border: '2px solid rgba(184,134,11,0.45)',
        position: 'relative',
        overflow: 'hidden',
        p: { xs: 3.5, md: 5 },
        mb: 5,
      }}
    >
      {/* Warm radial glow — lighter center */}
      <Box sx={{
        position: 'absolute',
        inset: 0,
        background: 'radial-gradient(ellipse at 35% 30%, rgba(184,134,11,0.18) 0%, rgba(251,191,36,0.06) 40%, transparent 70%)',
        pointerEvents: 'none',
      }} />
      {/* Subtle top-edge highlight */}
      <Box sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '120px',
        background: 'linear-gradient(180deg, rgba(255,255,255,0.04) 0%, transparent 100%)',
        pointerEvents: 'none',
      }} />

      <Box sx={{ position: 'relative', zIndex: 1 }}>
        <PioneerContent compact={false} ctaSlot={ctaButton} />
      </Box>
    </Box>
  );
};

export default PioneerBanner;
